module.exports = __webpack_public_path__ + "static/assets/ac55c7ffec30822a20359870bde86f8c.ttf";